"use client";

import { useEffect, useRef } from "react";

const heroPoster = "/landing/hero-poster-e8c81ff7282a.webp";

export function HeroVideo({ label }: { label: string }) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (!video) {
      return;
    }

    const updatePlayback = () => {
      if (reducedMotion.matches) {
        video.pause();
        video.currentTime = 0;
        return;
      }

      void video.play().catch(() => {
        // Browser autoplay policy may still pause decorative media.
      });
    };

    updatePlayback();
    reducedMotion.addEventListener("change", updatePlayback);

    return () => {
      reducedMotion.removeEventListener("change", updatePlayback);
    };
  }, []);

  return (
    <>
      <link rel="preload" as="image" href={heroPoster} fetchPriority="high" />
      <video
        ref={videoRef}
        className="hero-video block w-full bg-deep-ink object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        poster={heroPoster}
        aria-label={label}
      >
        <source
          src="/landing/hero-desktop-071291c03948.mp4"
          type="video/mp4"
          media="(prefers-reduced-motion: no-preference)"
        />
      </video>
    </>
  );
}
